/* eslint-disable no-unused-vars */
import userManagement from '../../providers/userManagement';

const state = {
  tutorials: {
    SCENARIO_BUILDER: null,
    SCENARIO_SELECT: null,
    SCENARIO_LOGIC: null,
    ORG_MANAGEMENT: null,
  },
};

const getters = {
  getTutorialsMap: state => state.tutorials,
};

const actions = {
  async fetchTutorials({ commit }, params) {
    const { category, productType } = params;
    if (state.tutorials[category] !== null) {
      return;
    }
    const queryParams = { filter: { category, $or: [{productType: null}, {productType}] } };
    const [ tutorialResponse ] = await Promise.all([
      userManagement.get('/tutorials', queryParams),
    ]);
    const tutorials = tutorialResponse.data.tutorials;
    const processedList = tutorials
      .sort((firstItem, secondItem) => firstItem.ordinal - secondItem.ordinal);
    commit('setTutorials', { category, tutorials: processedList });
  },
};

const mutations = {
  setTutorials(state, params) {
    state.tutorials[params.category] = params.tutorials;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};